<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="naam">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam </th>
        <td mat-cell *matCellDef="let row"> {{row.naam}} </td>
    </ng-container>

	<ng-container matColumnDef="datumKalibratie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum kalibratie </th>
        <td mat-cell *matCellDef="let row"> {{row.datumKalibratie | date}} </td>
    </ng-container>

	<ng-container matColumnDef="datumOproep">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum oproep </th>
        <td mat-cell *matCellDef="let row"> {{row.datumOproep | date}} </td>
    </ng-container>

    <ng-container matColumnDef="datumMail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum mail </th>
        <td mat-cell *matCellDef="let row"> {{row.datumMail | date}} </td>
    </ng-container>
</mg-table>
